import { render } from "./EditInventory.vue?vue&type=template&id=733e4b21"
import script from "./EditInventory.vue?vue&type=script&lang=js"
export * from "./EditInventory.vue?vue&type=script&lang=js"
script.render = render

export default script